import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAmitriptyline} from "./TextDrugAmitriptyline"


export default function Amitriptyline() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name='Amitriptyline' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Amitriptyline - PGx Recommendation"
        content={ <TextDrugAmitriptyline />}

        />

</>
)}